import React from "react";
import {
  CHeader,
  CToggler,
  CHeaderBrand,
  CHeaderNav,
  CHeaderNavItem,
  CHeaderNavLink,
  CSubheader,
  CBreadcrumbRouter,
  CLink,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { connect } from "react-redux";

import { setMenuToggle } from "../redux/actions";
import Logo from "../assets/logos/logo.png";

// routes config
import routes from "../routes";

import {
  TheHeaderDropdown,
  TheHeaderDropdownMssg,
  TheHeaderDropdownNotif,
  TheHeaderDropdownTasks,
} from "./index";

const TheHeader = (props) => {
  const { sidebarShow } = props;

  const toggleSidebar = () => {
    const val = [true, "responsive"].includes(sidebarShow)
      ? false
      : "responsive";
    props.setMenuToggle(val);
  };

  const toggleSidebarMobile = () => {
    const val = [false, "responsive"].includes(sidebarShow)
      ? true
      : "responsive";
    props.setMenuToggle(val);
  };

  return (
    <CHeader withSubheader>
      <CToggler
        inHeader
        className="ml-md-3 d-lg-none"
        onClick={toggleSidebarMobile}
      />
      <CToggler
        inHeader
        className="ml-3 d-md-down-none"
        onClick={toggleSidebar}
      />
      <CHeaderBrand className="mx-auto d-lg-none" to="/">
        {/* <CIcon name="logo" height="48" alt="Logo"/> */}
        <img src={Logo} alt="Carbonatixaudio logo" style={{ width: "40px" }} />
      </CHeaderBrand>

      <CHeaderNav className="d-md-down-none mr-auto">
        <CBreadcrumbRouter
          className="border-0 c-subheader-nav m-0 px-0 px-md-3"
          routes={routes}
        />
      </CHeaderNav>

      <CHeaderNav className="px-3">
        {/*
          <TheHeaderDropdownTasks/>
          <TheHeaderDropdownMssg/>
        */}
        <TheHeaderDropdown />
      </CHeaderNav>
    </CHeader>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
  sidebarShow: state.setting.sidebarShow,
});
export default connect(mapStateToProps, { setMenuToggle })(TheHeader);
